import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { classNameWithModifiers as withMods } from 'helpers/class-name';
import { Sidenav } from 'features/Sidenav';
import Breakpoint from 'components/Breakpoint';
import { DropdownScreenHost } from 'components/Dropdown';
import { RHFDevToolsHost } from 'components/HookForm';
// Importing Modal container directly to avoid circular dependencies elsewhere in the app
import ModalHost from 'components/Modal/ModalContainer';
import ComponentErrorBoundary from 'components/ComponentErrorBoundary';
import './LayoutV2.scss';

const AppLayout = ({ children, hideNav, hideNavVisibility, navIsOpen }) => (
  <ComponentErrorBoundary>
    <Helmet>
      <title>Partner Dashboard | ClassPass</title>
    </Helmet>
    {!hideNav && <Sidenav />}
    <ComponentErrorBoundary>{children}</ComponentErrorBoundary>
    <ModalHost />
    <DropdownScreenHost />
    {process.env.NODE_ENV !== 'production' && <RHFDevToolsHost />}
    <div
      role="presentation"
      className={withMods('main__open-nav-overlay', { open: !hideNav && navIsOpen })}
      onClick={hideNavVisibility}
    />
    {process.env.NODE_ENV !== 'production' && <Breakpoint />}
  </ComponentErrorBoundary>
);

AppLayout.propTypes = {
  children: PropTypes.node,
  hideNavVisibility: PropTypes.func,
  hideNav: PropTypes.bool,
  navIsOpen: PropTypes.bool,
};

export default AppLayout;
